import { Box, Tabs, styled } from '@mui/material';

// The data grids draw their border with MUI's palette.TableCell.border, which this MUI version does
// not expose on the Palette type. These are the values it resolves to; palette.divider is a shade
// off in dark, and a panel has to match the grid a sibling tab opens onto.
const GRID_BORDER_COLOR = { light: '#e0e0e0', dark: '#515151' };

// Page-level view switcher: a row of panel tabs where the selected one reads as the front sheet,
// rather than the underlined tabs MUI ships by default.
export const ViewTabs = styled(Tabs)(({ theme }) => ({
  minHeight: '40px',
  '& .MuiTab-root': {
    minHeight: '40px',
    height: '40px',
    backgroundColor: theme.palette.background.default,
    border: 'none',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    color: theme.palette.text.secondary,
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 400,
    padding: '0 20px',
    minWidth: 'auto',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
  },
  '& .MuiTab-root .MuiSvgIcon-root': {
    fontSize: '18px',
    color: theme.palette.secondary.main,
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

// The surface a tab opens onto, for views that do not bring their own. A data grid already draws
// this exact border and radius, so a tab showing one needs no panel around it; a tab showing
// anything else does, or its content floats under the tab strip.
export const TabPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${GRID_BORDER_COLOR[theme.palette.mode]}`,
  borderRadius: '6px',
  backgroundColor: theme.palette.background.paper,
}));
